import { getAmplitudeInstance } from '../amplitudeHelpers';
import CustomRouteActionTaken from '../enums/CustomRouteActionTaken';
import CustomRouteMode from '../enums/CustomRouteMode';
import CustomRoutePOI from '../enums/CustomRoutePOI';

type logCustomRouteUpdatedParams = {
  custom_route_mode?: CustomRouteMode;
  entry_point_location: CustomRouteActionTaken;
  poi_add_location?: CustomRoutePOI;
  smart_route_menu_activity?: boolean;
};

/**
 * Catch-all event that encompasses all route building interactions between starting and saving. inclusive of dragging, tapping, drawing, etc.
 * @param params - Attributes to log with the amplitude event
 * @param params.custom_route_mode - Mode the user was in when the custom route updated (tap, free draw, smart draw)
 * @param params.entry_point_location - Action that the user took when building a custom route
 * @param params.poi_add_location - For 'add POI to route' action only
 * @param params.smart_route_menu_activity - TRUE if the updated action comes from the smart route menu
 */
const logCustomRouteUpdated = (
  { custom_route_mode, entry_point_location, poi_add_location, smart_route_menu_activity }: logCustomRouteUpdatedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'custom route updated',
    {
      'custom route mode': custom_route_mode,
      'entry point location': entry_point_location,
      'poi add location': poi_add_location,
      'smart route menu activity': smart_route_menu_activity
    },
    callback
  );
};

export default logCustomRouteUpdated;
